export const haveSaturdays = (dates?: string[]): boolean =>
  dates?.some((date) => new Date(date).getDay() === 6) || false;

export const haveSundays = (dates?: string[]): boolean =>
  dates?.some((date) => new Date(date).getDay() === 0) || false;
